import styles from './InputText.module.css';
import { classList } from '../../helpers/classList';
import { FormLabel } from '../FormLabel';
import { FieldError } from '../FieldError';
import { HTMLInputTypeAttribute } from 'react';
import { Checkbox } from '../Checkbox';

export interface InputTextProps {
  id?: string;
  name?: string;
  placeholder?: string;
  state?: 'normal' | 'valid' | 'error';
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  error?: string;
  type?: HTMLInputTypeAttribute | undefined;
  className?: string;
  label?: string;
  // Guidance shown under the label, in the same place and style TextArea puts
  // it: an example of what the field takes, or what it is for
  description?: string | React.ReactNode;
  value?: string;
  min?: string | number;
  max?: string | number;
  checked?: boolean;
  prefix?: string;
  suffix?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  onCheckedChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const InputText = (props: InputTextProps) => {
  // possible visual states: ['normal' or undefined, 'valid', 'error']
  const state = props.state && props.state != 'normal' ? props.state : undefined;

  return (
    <div className={props.className}>
      {props.checked !== undefined && (
        <Checkbox
          className={styles.checkbox}
          labelClassName={styles.checkboxLabel}
          checked={props.checked}
          onChange={props.onCheckedChange}
          value={''}
          text={props.label ?? ''}
        />
      )}
      {props.checked === undefined && (
        <FormLabel htmlFor={props.id} required={props.required}>
          {props.label}
        </FormLabel>
      )}
      {props.description && <p className='description'>{props.description}</p>}
      <div className={classList(styles['input-container'], state ? styles[`input-container-${state}`] : undefined)}>
        {props.prefix && <span className={classList(styles['input-addon'], styles.prefix)}>{props.prefix}</span>}
        <input
          className={classList(styles.input, state ? styles[`input-${state}`] : undefined)}
          id={props.id}
          name={props.name}
          value={props.value}
          type={props.type}
          min={props.min}
          max={props.max}
          placeholder={props.placeholder}
          readOnly={props.readOnly}
          disabled={props.disabled}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onKeyDown={props.onKeyDown}
        />
        {props.suffix && <span className={classList(styles['input-addon'], styles.suffix)}>{props.suffix}</span>}
      </div>
      {props.error && <FieldError>{props.error}</FieldError>}
    </div>
  );
};
